<template>
  <el-dialog :visible.sync="dialogFormVisible" :title="titles[updateType]" :before-close="close">
    <el-form ref="form" label-width="120px" :model="initForm" :rules="rules">
      <el-form-item label="服务器名称" prop="server_name">
        <el-input v-model="initForm.server_name" placeholder="请输入服务器名称"></el-input>
      </el-form-item>

      <el-form-item label="云平台" prop="cloud">
        <el-select v-model="initForm.cloud" placeholder="请选择云平台">
        <el-option
          v-for="cloud in cloudEnvList"
          :label="cloud"
          :key="cloud"
          :value="cloud"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="公网IP" prop="public_ip">
        <el-input v-model="initForm.public_ip" placeholder="请输入公网IP"></el-input>
      </el-form-item>

      <el-form-item label="内网IP" prop="private_ip">
        <el-input v-model="initForm.private_ip" placeholder="请输入内网IP"></el-input>
      </el-form-item>

      <el-form-item label="是否有csmain" prop="has_csmain">
        <el-select v-model="initForm.has_csmain" placeholder="是否有csmain">
        <el-option
          v-for="status in hasStatus"
          :label="status"
          :key="status"
          :value="status"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="是否有csconfig" prop="has_csconfig">
        <el-select v-model="initForm.has_csconfig" placeholder="是否有csconfig">
          <el-option
            v-for="status in hasStatus"
            :label="status"
            :key="status"
            :value="status"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="备注" prop="desc">
        <el-input v-model="initForm.desc" placeholder="备注"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSubmit">提交</el-button>
      <el-button @click="$emit('close')" type="info">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { HasStatus } from "@/components/Index/data.js";

export default {
  props: {
    initForm: {},
    updateType: {},
    cloudEnvList: {}
  },
  data() {
    return {
      dialogFormVisible: true,
      rules: {
        cloud: [{required: true, message: "请输入云平台名称(英文简写)", trigger: "blur"}],
        server_name: [{required: true, message: "请输入服务器名称(英文简写)", trigger: "blur"}],
        public_ip: [{required: false, message: "请输入公网IP", trigger: "blur"}],
        private_ip: [{required: true, message: "请输入内网IP", trigger: "blur"}],
        has_csmain: [{required: true, message: "请选择", trigger: "blur"}],
        has_csconfig: [{ required: true, message: "请选择", trigger: "blur" }],
        desc: [{required: false, message: "请填写备注信息", trigger: "blur"}]
      },
      titles: {
        add: "新增",
        edit: "编辑"
      },
      hasStatus: HasStatus
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        var method = "";
        var url = "";
        var msg = "操作失败";
        var formData = {
              cloud: this.initForm.cloud,
              server_name: this.initForm.server_name,
              public_ip: this.initForm.public_ip,
              private_ip: this.initForm.private_ip,
              has_csmain: +(this.initForm.has_csmain === '是'),
              has_csconfig: +(this.initForm.has_csconfig === "是"),
              desc: this.initForm.desc
        };
        if (!valid) {
          alert("请检查输入是否正确！");
          return false;
        }
        this.dialogFormVisible = false;
        if (this.updateType === "add") {
          method = "post";
          url = "cloud/server/";
          msg = "添加成功";
        } else if (this.updateType === "edit") {
          method = "patch";
          url = "cloud/server/" + this.initForm.id + "/";
          msg = "编辑成功";
        } else{
          return false;
        };
        this.$http[method](
          url,
          formData,
          () => {
            this.$baseNotice.message(msg);
            this.$emit("close");
            this.$emit("update");
          }
        )
      });
    }
  }
};
</script>
